import { stateHelperModule } from '../state-helper/state-helper';
import { uiRouterStateModule } from '../../vendor/ui-router-module';

export const paginationHelperModule = angular
  .module('Q.helpers.pagination-helper', [
    uiRouterStateModule,
    stateHelperModule,
  ])

  .factory('paginationHelper', function ($state, stateHelper) {
    const clamp = (min, n, max) => Math.max(min, Math.min(max, n));
    const protect = (n) => (isNaN(n) ? 0 : n);

    return {
      /**
       * Calculate pagination data for a set of items
       * @param total {number} Total number of items
       * @param perPage {number} Number of items per page
       * @param page {number} Current page, defaults to 1
       * @param currentIndex {number} Current item index, will override opts.page
       * @param minPerPage {number} minimum allowed page size, defaults to 1
       * @param maxPerPage {number} max allowed page size, defaults to Infinity
       * @param buffer {number} Allowed overage to disable pagination (defaults to 1 if perPage is > 2)
       * @returns {*} A collection of properties that can be used to render information about the current page
       */
      calc({
        total,
        perPage,
        page,
        currentIndex,
        minPerPage = 1,
        maxPerPage = Infinity,
        buffer = 1,
      } = {}) {
        perPage = +perPage;
        let currentPerPage = clamp(
          minPerPage,
          perPage || minPerPage,
          maxPerPage,
        );

        if (buffer === 1 && currentPerPage < 3) buffer = 0;

        if (total <= currentPerPage + buffer) {
          // override perPage since we only have «buffer» items on the next page
          currentPerPage = total;
        }

        const pages = Math.ceil(protect(total / currentPerPage));

        currentIndex = Math.floor(currentIndex);

        if (isNaN(currentIndex) || currentIndex < 0 || currentIndex >= total) {
          currentIndex = false;
          page = clamp(1, Math.floor(page) || 1, pages);
        } else {
          page = Math.floor(protect(currentIndex / currentPerPage)) + 1;
        }

        const first = (page - 1) * currentPerPage;

        return {
          total,
          perPage,
          currentPerPage,
          minPerPage,
          maxPerPage,
          page,
          pages,
          first,
          last: Math.min(total, first + currentPerPage) - 1,
          hasPrev: page > 1,
          hasNext: page < pages,
          currentIndex,
        };
      },

      /**
       * Updates an autolist's pagination, and, if provided, sets the uiRouter param for the correct
       * page.
       *
       * Designed to be used within a promise chain for the item being paged to.
       *
       * @usage
       * Model.get(id)
       *     .then(paginationHelper.updateList(modelList, 'modelPage'));
       *
       * @param list List to update
       * @param param Optional uiRouter state param to update
       * @returns {Function} to be added to the promise chain
       */
      updateList(list, param) {
        return function (item) {
          if (item && (angular.isString(item) || item.id)) {
            let page = list.setPageFor(item);
            if (
              param &&
              page !== +$state.params[param] &&
              $state.current &&
              !$state.current.abstract
            ) {
              stateHelper.redirectAfterResolve('.', { [param]: page });
            }
          }
          return item;
        };
      },
    };
  });
